module.exports = __webpack_public_path__ + "static/img/2.8e47d503.png";